import browserDetect from "../../node_modules/browser-detect/dist/browser-detect.umd.js";

export function isOldVersion() {
    let isBrowserOld = false;
    const browserInfo = browserDetect();

    if (browserInfo) {
        const version = browserInfo.versionNumber;
        switch (browserInfo.name) {
            case "chrome":
                {
                    isBrowserOld = version < 58;
                    break;
                }
            case "edge":
                {
                    isBrowserOld = version < 14;
                    break;
                }
            case "safari":
                {
                    isBrowserOld = version < 10;
                    break;
                }
            case "firefox":
                {
                    isBrowserOld = version < 54;
                    break;
                }
            case "opera":
                {
                    isBrowserOld = version < 50;
                    break;
                }
            case "ie":
                {
                    isBrowserOld = version < 11;
                    break;
                }
            default:
                {
                    isBrowserOld = true;
                }
        }
    }
    return isBrowserOld;
}
